import { render, staticRenderFns } from "./add_archives.vue?vue&type=template&id=12a8b8a9&scoped=true"
import script from "./add_archives.vue?vue&type=script&lang=js"
export * from "./add_archives.vue?vue&type=script&lang=js"
import style0 from "./add_archives.vue?vue&type=style&index=0&id=12a8b8a9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a8b8a9",
  null
  
)

export default component.exports